/**
 * MAB API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DocflowDialogButton } from './docflowDialogButton';


export interface DocflowFatfDialogModel { 
    /**
     * Disputable value with field name
     */
    searchFor: string;
    /**
     * Field label
     */
    field: string;
    /**
     * Matching label
     */
    matching: string;
    /**
     * Category label
     */
    category: string;
    /**
     * Category color
     */
    categoryColor: string;
    passButton: DocflowDialogButton;
    rejectButton: DocflowDialogButton;
    /**
     * Workflow method id
     */
    methodId: number;
    /**
     * Document instance id
     */
    instanceId: number;
}

